import { createHashHistory , createBrowserHistory } from "history";
export default createBrowserHistory();
// export default createHashHistory();
